export default {"src":"/_next/static/media/news-title.f82b78e5.svg","height":26,"width":54};